import React, { useEffect, useRef } from "react";
import { withStyles } from "@material-ui/styles";
import {connect} from 'react-redux';
import Typography from "@material-ui/core/Typography";
import ActionsMenu from "../../../../../../../ui/ActionsMenu";
import AddButton from "../../../../../../../ui/AddButton";
import StudentCard from "./StudentCard";
import CreateNew from "./CreateNew";
import AddExist from "./AddExist";
import { Grid } from "@material-ui/core";
import {
  getMasterClassStudents
} from "../../../store/actions";
import {
  addExistStudent,
  createNewStudent
} from "../../../store/send";
const defaultData = {
  createNewOpened: false,
  addExistingOpened: false
};

const styles = () => ({
  root: {
    width: "100%",
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
  label: {
    fontSize: 12
  },
  students: {
    paddingTop: 16,
    marginBottom: 24
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  fileInput: {
    display: 'none'
  },
  requestTable: {
    marginTop: "24px"
  }
});

const Students = ({ disabled, classes, editmode,
                    id, masterClassName,
                    groupStudents, getMasterClassStudents,
                    createNewStudent, isCreatingStudent, createdStudent,
                    addExistStudent, isAddingStudent, addedStudent}) => {
  const [data, setData] = React.useState(defaultData);
  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
  };

  useEffect(() => {
    getMasterClassStudents(id);
  }, [id]);

  React.useEffect(() => {
    if (createdStudent && createdStudent.success) {
      getMasterClassStudents(id);
    }
  }, [createdStudent]);

  const addactions = [
    {
      label: "Добавить нового",
      onClick: () => onChange("createNewOpened", true)
    },
    {
      label: "Выбрать из существующих",
      onClick: () => onChange("addExistingOpened", true)
    }
  ];

  const actions = [
    {
      label: "Удалить выбранные",
      disabled: true
    },
    {
      label: "Отключить выбранные",
      disabled: true
    }
  ];

  return (
    <div className={classes.root}>
      <CreateNew
        open={data.createNewOpened}
        handleClose={() => onChange("createNewOpened", false)}
        createStudent={data => {
          createNewStudent(data, id);
          onChange("createNewOpened", false);
        }}
        masterClassName={masterClassName || ''}
        masterClassId={id}
        isCreatingStudent={isCreatingStudent}
      />
      <AddExist open={data.addExistingOpened}
                handleClose={() => onChange("addExistingOpened", false)}
                masterClassName={masterClassName || ''}
                masterClassId={id}
                handleAccept={addExistStudent}
      />
      <div className={classes.top}>
        <Typography className={classes.heading}>Обучающиеся</Typography>
        {/*<ActionsMenu actions={actions} />*/}
        <AddButton actions={addactions} />
      </div>
      <div className={classes.students}>
        <Grid container spacing={2}>
          {groupStudents && groupStudents.map(student => (
            <Grid item xs={12} sm={12} md={6} lg={4} key={student.id}>
              <StudentCard
                data={student}
                masterClassId={id}
                reload={() => getMasterClassStudents(id)}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  groupStudents: state.masterClasses.groupStudents,
  isCreatingStudent: state.masterClasses.isCreatingStudent,
  createdStudent: state.masterClasses.createdStudent,
  isAddingStudent: state.masterClasses.isAddingStudent,
  addedStudent: state.masterClasses.addedStudent
});

const mapDispatchToProps = dispatch => ({
  getMasterClassStudents: id => dispatch(getMasterClassStudents(id)),
  createNewStudent: (id, data) => dispatch(createNewStudent(id, data)),
  addExistStudent: (groupId, studentId) => dispatch(addExistStudent(groupId, studentId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Students));
